(function () {
  var backgroundImageUrl = document.body.getAttribute(
    "data-background-image-url",
  );

  if (backgroundImageUrl && backgroundImageUrl.trim() !== "") {
    document.body.style.backgroundImage = 'url("' + backgroundImageUrl + '")';
  }
})();
